export default __webpack_public_path__ + "static/listing-page-calendar-934ac49b902321d94f8fdaf5df205926.png";